// src/render/registry.js

import Game2048 from "../components/page/Game2048";
import USGeographyQuiz from '../components/page/USGeographyQuiz'; 
import MathCrossword from '../components/page/MathCrossword'; 
import MathCrossword1 from '../components/page/MathCrossword1'; 
import NumerologyTest from '../components/page/NumerologyTest'; 
import BrainAgeQuiz from '../components/page/BrainAgeQuiz';
import GeographyQuiz from '../components/page/GeographyQuiz';
import TarotCardOfTheDay from '../components/page/TarotCardOfTheDay'; 
import IChingCaster from '../components/page/IChingCaster'; 
import HangmanGame from '../components/page/HangmanGame';
import SudokuApp from "../components/page/SudokuApp";
import Wordly from "../components/page/Wordly";
import CommonKnowledgeQuiz from '../components/page/CommonKnowledgeQuiz';
import MemoryMatch  from '../components/page/MemoryMatch'
import ToddlerMatchGame from '../components/page/ToddlerMatchGame';
import FindAfterSwapGame from '../components/page/FindAfterSwapGame';
import FindAfterSwapKeepTarget from '../components/page/FindAfterSwapGame';

export const COMPONENT_REGISTRY = {
  Game2048,USGeographyQuiz,MathCrossword,MathCrossword1,NumerologyTest,BrainAgeQuiz,GeographyQuiz,TarotCardOfTheDay,IChingCaster,HangmanGame,SudokuApp,Wordly,CommonKnowledgeQuiz,MemoryMatch,ToddlerMatchGame,FindAfterSwapGame,FindAfterSwapKeepTarget
};
export const TAG_ALIASES = {
"game-2048": "Game2048",
"game2048": "Game2048",
"g2048": "Game2048",
'usgeographyquiz': 'USGeographyQuiz',
'us-geography-quiz': 'USGeographyQuiz',
'mathcrossword': "MathCrossword", 
'mathcrossword1': "MathCrossword1", 
"numerology-test": "NumerologyTest",
"widget-numerology": "NumerologyTest",
"brain-age-quiz": "BrainAgeQuiz",
"geography-quiz": "GeographyQuiz" ,
"geographyquiz": "GeographyQuiz",
"tarot-card-of-the-day": "TarotCardOfTheDay",
"tarot-card": "TarotCardOfTheDay",
"i-ching-caster": "IChingCaster",
"i-ching": "IChingCaster",
"i-ching-caster": "IChingCaster",
"IChingCaster": "IChingCaster",
"ichingcaster": "IChingCaster",
"HangmanGame": "HangmanGame",
"hangman-game": "HangmanGame",
"hangman": "HangmanGame",
"sudoku-app": "SudokuApp",
"sudoku": "SudokuApp",
"sudoku-game": "SudokuApp",
"wordly": "Wordly",
"wordly-game": "Wordly",
"wordly-game": "Wordly",
"wordly-game": "Wordly",
"common-knowledge-quiz": "CommonKnowledgeQuiz",
"commonknowledgequiz": "CommonKnowledgeQuiz",
"MemoryMatch ":"MemoryMatch",
"memorymatch" : "MemoryMatch",
"toddler-match-game" : "ToddlerMatchGame",
"FindAfterSwapGame" : "FindAfterSwapGame",
"find-after-swap-game" : "FindAfterSwapGame",
"FindAfterSwapKeepTarget" : "FindAfterSwapKeepTarget",
"find-after-swap-keep-target" : "FindAfterSwapKeepTarget",
};